import { parseGeoJSONInput } from './geoBuffer';

function isFinitePair(point) {
  return (
    Array.isArray(point) &&
    point.length >= 2 &&
    Number.isFinite(Number(point[0])) &&
    Number.isFinite(Number(point[1]))
  );
}

function ringIsValid(ring) {
  return Array.isArray(ring) && ring.length >= 4 && ring.every(isFinitePair);
}

export function geometryIsUsable(geom) {
  if (!geom || typeof geom !== 'object') return false;
  if (geom.type === 'Polygon') {
    return Array.isArray(geom.coordinates) && ringIsValid(geom.coordinates[0]);
  }
  if (geom.type === 'MultiPolygon') {
    return (
      Array.isArray(geom.coordinates) && geom.coordinates.some((poly) => ringIsValid(poly?.[0]))
    );
  }
  return false;
}

function featureFromGeometry(geometry) {
  return { type: 'Feature', geometry, properties: {} };
}

/**
 * Normaliza Polygon, Feature ou FeatureCollection para FeatureCollection
 * só com polígonos válidos. Retorna null se não houver geometria usável.
 */
export function toFeatureCollection(value) {
  let parsed;
  try {
    parsed = parseGeoJSONInput(value);
  } catch {
    return null;
  }
  if (!parsed || typeof parsed !== 'object') return null;

  let features = [];
  if (parsed.type === 'FeatureCollection' && Array.isArray(parsed.features)) {
    features = parsed.features;
  } else if (parsed.type === 'Feature') {
    features = [parsed];
  } else if (parsed.type === 'Polygon' || parsed.type === 'MultiPolygon') {
    features = [featureFromGeometry(parsed)];
  } else {
    return null;
  }

  const usable = features
    .filter((feature) => feature && geometryIsUsable(feature.geometry || feature))
    .map((feature) =>
      feature.type === 'Feature' ? feature : featureFromGeometry(feature)
    );
  if (!usable.length) return null;
  return { type: 'FeatureCollection', features: usable };
}

export function isValidMapExtent(extent) {
  return (
    Array.isArray(extent) &&
    extent.length === 4 &&
    extent.every((n) => Number.isFinite(n)) &&
    extent[0] <= extent[2] &&
    extent[1] <= extent[3]
  );
}

/** Enquadra o source no mapa só se o canvas já tiver tamanho e o extent for finito. */
export function fitMapToSource(map, source, options = {}) {
  if (!map || !source || source.isEmpty()) return false;
  map.updateSize();
  const size = map.getSize();
  if (!size || size[0] < 8 || size[1] < 8) return false;
  const extent = source.getExtent();
  if (!isValidMapExtent(extent)) return false;
  map.getView().fit(extent, {
    padding: [28, 28, 28, 28],
    maxZoom: 18,
    duration: 0,
    ...options,
  });
  return true;
}
